import { Skeleton } from '@nexelem/components';
import { selectQueueNameById, useKanbanEventStore } from '../store';

type QueueCardProps = {
  queueId?: number;
};

export const QueueCard = ({ queueId }: QueueCardProps) => {
  const queueName = useKanbanEventStore(selectQueueNameById(queueId));

  return (
    <div className="col-span-2 border border-l-0 border-border-primary">
      <div className="sticky top-0">
        <div className="box-border flex w-full justify-center border-b border-border-primary px-2 pt-4 pb-3 break-all">
          {queueName ? (
            <span className="text-center text-t16-sb">{queueName}</span>
          ) : (
            <Skeleton className="h-5 w-4/5" />
          )}
        </div>
      </div>
    </div>
  );
};
